import React from 'react';
import { motion } from 'framer-motion';
export function OpeningHook() {
  return <section className="w-full bg-navy-800 px-4 py-20" data-id="element-123">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="max-w-4xl mx-auto" data-id="element-124">
        <div className="border-l-4 border-gold pl-6" data-id="element-125">
          <p className="text-gray-300 text-lg leading-relaxed italic" data-id="element-126">
            Son las 3 de la mañana y tus ojos están abiertos de par en par. El
            silencio de la casa parece aumentar el volumen de tus
            preocupaciones. Revisas el reloj por quinta vez y sientes ese nudo
            en el estómago al calcular que solo te quedan 4 horas antes de que
            suene la alarma.
          </p>
          <p className="text-gray-300 text-lg leading-relaxed italic mt-6" data-id="element-127">
            Has intentado todo: oscuridad total, baños calientes y aplicaciones
            de ruido blanco. Pero nada funciona porque tu mente sigue corriendo
            a mil por hora. Tu cuerpo está agotado, pero tu "fuego interno" no
            te permite desconectarte.
          </p>
        </div>
      </motion.div>
    </section>;
}